<!-- No bg-* class: inherit the global .modal-header colour (#4d6b7e), the same as .btn-success,
     so this header matches the buttons and the other modals in this flow. -->
<div class="modal-header">
    <h5 class="modal-title text-white" data-testid="new-message-modal-title">Send approved template</h5>
    <button type="button" class="btn-close btn-close-white" (click)="cancel()" data-testid="new-message-modal-close"></button>
</div>
<div class="modal-body" data-testid="new-message-modal-body">
    <!-- To field -->
    <div class="mb-3">
        <label class="form-label fw-semibold">To:</label>
        <!-- UNIVAPLAT-2550: in bulk mode this shows the recipient summary instead of a masked phone -->
        <input type="text" class="form-control" [value]="toFieldValue" readonly data-testid="new-message-to-field">
    </div>

    <!-- Loading templates spinner -->
    <div *ngIf="loadingTemplates" class="text-center py-3" data-testid="templates-loading">
        <div class="spinner-border spinner-border-sm text-secondary" role="status"></div>
        <span class="ms-2 text-muted">Loading templates…</span>
    </div>

    <!-- Template error -->
    <div *ngIf="templateError" class="alert alert-danger" data-testid="template-error">
        <span data-testid="template-error-text">{{ templateError }}</span>
        <button class="btn btn-sm btn-outline-danger ms-2" type="button" (click)="loadTemplates()" data-testid="template-retry-btn">Retry</button>
    </div>

    <ng-container *ngIf="!loadingTemplates && !templateError">
        <form [formGroup]="form">
            <!-- Template dropdown -->
            <div class="mb-3">
                <label class="form-label fw-semibold">Select template</label>
                <ng-select
                    [items]="templates"
                    bindLabel="friendlyName"
                    bindValue="templateSid"
                    placeholder="Select a template…"
                    formControlName="templateSid"
                    (change)="onTemplateSelect($event)"
                    data-testid="template-select">
                </ng-select>
            </div>

            <!-- Variable slots -->
            <ng-container *ngIf="selectedTemplate && variablesArray.length > 0">
                <div formArrayName="variables" data-testid="variable-slots">
                    <div *ngFor="let ctrl of variablesArray.controls; let i = index" class="mb-3">
                        <label class="form-label">{{ variableLabel(i) }}</label>
                        <input type="text" class="form-control" [formControlName]="i" placeholder="Enter value…" [attr.data-testid]="'variable-input-' + i">
                    </div>
                </div>
            </ng-container>

            <!-- Preview pane -->
            <div *ngIf="selectedTemplate" class="mb-3">
                <label class="form-label fw-semibold">Preview</label>
                <div class="border rounded p-3 bg-light preview-pane" data-testid="message-preview">{{ previewBody || 'This template will be sent as configured in Twilio.' }}</div>
            </div>
        </form>
    </ng-container>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="cancel()" data-testid="new-message-cancel-btn">Cancel</button>
    <button type="button" class="btn btn-success" [disabled]="isSendDisabled" (click)="openConfirmModal()" data-testid="new-message-send-btn">Send</button>
</div>
